function toParagraph(text: string) {
  const lines = text.split('\n');
  let result = '';
  for (const line of lines) {
    result += `<p>${line}</p>`;
  }
  return result;
}

const slideOne = {
      title: 'View One',
      image: 'assets/img/slide-1.png',
      thumb: 'assets/img/slide-1.png',
      hotspots: [
        {
          title: 'SC Café: QSR',
          number: 1,
          coordinates: {
            top: '45%',
            left: '25%'
          },
          link: 'https://structuralconcepts.com/markets/qsr',
          linkTitle: 'Learn About our QSR Solutions',
          content: toParagraph('Learn how we are meeting restaurants’ expanded need for high-quality, fresh food offerings with a diverse collection of reliable, flexible merchandisers that work harder, better display and sell more food, and minimize operating costs.'),
          images: ['https://djnnwndagrfti.cloudfront.net/content/nra/cafe_image1.jpg', 'https://djnnwndagrfti.cloudfront.net/content/nra/cafe_image2.jpg']
        },
        {
          title: 'Autonomous Retail Merchandiser (ARM)',
          number: 2,
          coordinates: {
            top: '45%',
            left: '50%'
          },
          link: 'https://structuralconcepts.com/arm',
          linkTitle: 'Learn About the ARM',
          content: toParagraph('Structural Concepts is the only refrigerated manufacturer to design and manufacture a <strong>complete smart solution</strong> for autonomous shopping.\n\nOffsetting labor challenges, an appealing refrigerated or ambient merchandising format with increased capacity, a cashier-less transactional system, and the ability to streamline inventory management, this single solution provides a quick payback turning into increased profitability.'),
          images: ['https://djnnwndagrfti.cloudfront.net/content/nra/ARM_image2.jpg', 'https://djnnwndagrfti.cloudfront.net/content/nra/ARM_image3.jpg', 'https://djnnwndagrfti.cloudfront.net/content/nra/ARM_image4.jpg', 'https://djnnwndagrfti.cloudfront.net/content/nra/ARM_image1.jpg'],
          videos: ['rDBN2lb8SsI']
        },
        {
          title: 'Refrigerated & Heated Self-Service Case (B5024RH)',
          number: 3,
          coordinates: {
            top: '43%',
            left: '80%'
          },
          link: 'https://structuralconcepts.com/products/b5024rh',
          linkTitle: 'View Product',
          content: toParagraph('New larger size heated and refrigerated self-service case provides a vertical combination of both hot and cold temperatures allowing foodservice operators to expand their offering in a single space, maximize impulse purchases, and elevate the customer experience.'),
          images: ['https://djnnwndagrfti.cloudfront.net/content/nra/Refrigerated-Heated-B5024RH_image-1.jpg','https://djnnwndagrfti.cloudfront.net/content/nra/Refrigerated-Heated-B5024RH_image-3.jpg','https://djnnwndagrfti.cloudfront.net/content/nra/Refrigerated-Heated-B5024RH_image-2.jpg', ],
          videos: ['OGNA7aob3T0']
        },
      ]
};

const slideTwo = {
    title: 'View Two',
    image: 'assets/img/slide-2.png',
    thumb: 'assets/img/slide-2.png',
    hotspots: [
      {
        title: 'Autonomous Retail Merchandiser (ARM)',
        number: 2,
        coordinates: {
          top: '43%',
          left: '54%'
        },
        link: 'https://structuralconcepts.com/arm',
        linkTitle: 'Learn About the ARM',
        content: toParagraph('Structural Concepts is the only refrigerated manufacturer to design and manufacture a <strong>complete smart solution</strong> for autonomous shopping.\n\nOffsetting labor challenges, an appealing refrigerated or ambient merchandising format with increased capacity, a cashier-less transactional system, and the ability to streamline inventory management, this single solution provides a quick payback turning into increased profitability.'),
        images: ['https://djnnwndagrfti.cloudfront.net/content/nra/ARM_image2.jpg', 'https://djnnwndagrfti.cloudfront.net/content/nra/ARM_image3.jpg', 'https://djnnwndagrfti.cloudfront.net/content/nra/ARM_image4.jpg', 'https://djnnwndagrfti.cloudfront.net/content/nra/ARM_image1.jpg'],
        videos: ['rDBN2lb8SsI']
      },
      {
        title: 'Refrigerated & Heated Self-Service Case (B5024RH)',
        number: 3,
        coordinates: {
          top: '45%',
          left: '78%'
        },
        link: 'https://structuralconcepts.com/products/b5024rh',
        linkTitle: 'View Product',
        content: toParagraph('New larger size heated and refrigerated self-service case provides a vertical combination of both hot and cold temperatures allowing foodservice operators to expand their offering in a single space, maximize impulse purchases, and elevate the customer experience.'),
        images: ['https://djnnwndagrfti.cloudfront.net/content/nra/Refrigerated-Heated-B5024RH_image-1.jpg','https://djnnwndagrfti.cloudfront.net/content/nra/Refrigerated-Heated-B5024RH_image-3.jpg','https://djnnwndagrfti.cloudfront.net/content/nra/Refrigerated-Heated-B5024RH_image-2.jpg', ],
        videos: ['OGNA7aob3T0']
      },
      {
        title: 'FreshWatch',
        number: 4,
        coordinates: {
          top: '45%',
          left: '45%'
        },
        link: 'https://youtu.be/iyceOf7_fFE',
        linkTitle: 'Learn More',
        content: toParagraph('An advanced, cloud-based solution providing real-time monitoring, remote diagnostics, and energy optimization that ensures food safety, reduces waste, and improves operational efficiency. With proactive alerts and detailed insights on power consumption and equipment performance, operators can minimize downtime, lower costs, and boost profitability.'),
        images: ['https://djnnwndagrfti.cloudfront.net/content/nra/FreshWatch-Logo.png']
      },
    ]
};

const slideThree = {
  title: 'View Three',
  image: 'assets/img/slide-3.png',
  thumb: 'assets/img/slide-3.png',
  hotspots: [
    {
      title: 'Refrigerated & Heated Self-Service Case (B5024RH)',
      number: 3,
      coordinates: {
        top: '26%',
        left: '65%'
      },
      link: 'https://structuralconcepts.com/products/b5024rh',
      linkTitle: 'View Product',
      content: toParagraph('New larger size heated and refrigerated self-service case provides a vertical combination of both hot and cold temperatures allowing foodservice operators to expand their offering in a single space, maximize impulse purchases, and elevate the customer experience.'),
      images: ['https://djnnwndagrfti.cloudfront.net/content/nra/Refrigerated-Heated-B5024RH_image-1.jpg','https://djnnwndagrfti.cloudfront.net/content/nra/Refrigerated-Heated-B5024RH_image-3.jpg','https://djnnwndagrfti.cloudfront.net/content/nra/Refrigerated-Heated-B5024RH_image-2.jpg', ],
      videos: ['OGNA7aob3T0']
    },
    {
      title: 'FreshWatch',
      number: 4,
      coordinates: {
        top: '46%',
        left: '50%'
      },
      link: 'https://youtu.be/iyceOf7_fFE',
      linkTitle: 'Learn More',
      content: toParagraph('An advanced, cloud-based solution providing real-time monitoring, remote diagnostics, and energy optimization that ensures food safety, reduces waste, and improves operational efficiency. With proactive alerts and detailed insights on power consumption and equipment performance, operators can minimize downtime, lower costs, and boost profitability.'),
      images: ['https://djnnwndagrfti.cloudfront.net/content/nra/FreshWatch-Logo.png']
    },
  ]
};

const slideFour = {
  title: 'View Four',
  image: 'assets/img/slide-4.png',
  thumb: 'assets/img/slide-4.png',
  hotspots: [
    {
      title: 'FreshWatch',
      number: 4,
      coordinates: {
        top: '45%',
        left: '55%'
      },
      link: 'https://youtu.be/iyceOf7_fFE',
      linkTitle: 'Learn More',
      content: toParagraph('An advanced, cloud-based solution providing real-time monitoring, remote diagnostics, and energy optimization that ensures food safety, reduces waste, and improves operational efficiency. With proactive alerts and detailed insights on power consumption and equipment performance, operators can minimize downtime, lower costs, and boost profitability.'),
      images: ['https://djnnwndagrfti.cloudfront.net/content/nra/FreshWatch-Logo.png']
    },
    {
      title: 'Autonomous Retail Merchandiser (ARM) Age Verification Feature',
      number: 5,
      coordinates: {
        top: '43%',
        left: '46%'
      },
      link: 'https://structuralconcepts.com/arm',
      linkTitle: 'Learn About the ARM',
      content: toParagraph('Verify user\’s age through an ID scanner that can read and authenticate government-issued identifications.  Technology protects businesses and helps maintain community standards by preventing underage access to restricted items.\n\nOperates without the need for a human cashier to verify age while ensuring safety and compliance of the operation.\n\nAvailable mid 2025.'),
      images: ['https://djnnwndagrfti.cloudfront.net/content/nra/ARM_image2.jpg', 'https://djnnwndagrfti.cloudfront.net/content/nra/ARM_image3.jpg', 'https://djnnwndagrfti.cloudfront.net/content/nra/ARM_image4.jpg', 'https://djnnwndagrfti.cloudfront.net/content/nra/ARM_image1.jpg']
    }
  ]
};

const slideFive = {
  title: 'View Five',
  image: 'assets/img/slide-5.png',
  thumb: 'assets/img/slide-5.png',
  hotspots: [
    {
      title: 'Autonomous Retail Merchandiser (ARM) Age Verification Feature',
      number: 5,
      coordinates: {
        top: '45%',
        left: '50%'
      },
      link: 'https://structuralconcepts.com/arm',
      linkTitle: 'Learn About the ARM',
      content: toParagraph('Verify user\’s age through an ID scanner that can read and authenticate government-issued identifications.  Technology protects businesses and helps maintain community standards by preventing underage access to restricted items.\n\nOperates without the need for a human cashier to verify age while ensuring safety and compliance of the operation.\n\nAvailable mid 2025.'),
      images: ['https://djnnwndagrfti.cloudfront.net/content/nra/ARM_image2.jpg', 'https://djnnwndagrfti.cloudfront.net/content/nra/ARM_image3.jpg', 'https://djnnwndagrfti.cloudfront.net/content/nra/ARM_image4.jpg', 'https://djnnwndagrfti.cloudfront.net/content/nra/ARM_image1.jpg']
    }
  ]
};


const slideSix = {
  title: 'View Six',
  image: 'assets/img/slide-6.png',
  thumb: 'assets/img/slide-6.png',
  hotspots: [
    {
      title: 'myDesignPro Product Configurator',
      number: 6,
      coordinates: {
        top: '44%',
        left: '41%'
      },
      link: 'https://www.youtube.com/watch?v=E4dqTGHWWyE',
      linkTitle: 'Learn About myDesignPro',
      content: toParagraph('Multi-platform 3D product configurator that visually demonstrates how equipment will look and line up.   Add features and modify options, such as how the case will appear in an actual line-up, determine shelving or other accessories, include a specific exterior or interior finish, and bring in any other available option.  See results fast and export them as PDF, Revit or AutoCAD.'),
      images: ['https://djnnwndagrfti.cloudfront.net/content/nra/myDesignPro_image1.jpg','https://djnnwndagrfti.cloudfront.net/content/nra/myDesignPro_image3.jpg','https://djnnwndagrfti.cloudfront.net/content/nra/myDesignPro_image2.png', ],
      videos: ['E4dqTGHWWyE']
    },
  ]
};


const slideSeven = {
  title: 'View Seven',
  image: 'assets/img/slide-7.png',
  thumb: 'assets/img/slide-7.png',
  hotspots: [
    {
      title: 'myDesignPro Product Configurator',
      number: 6,
      coordinates: {
        top: '46%',
        left: '47%'
      },
      link: 'https://www.youtube.com/watch?v=E4dqTGHWWyE',
      linkTitle: 'Learn About myDesignPro',
      content: toParagraph('Multi-platform 3D product configurator that visually demonstrates how equipment will look and line up.   Add features and modify options, such as how the case will appear in an actual line-up, determine shelving or other accessories, include a specific exterior or interior finish, and bring in any other available option.  See results fast and export them as PDF, Revit or AutoCAD.'),
      images: ['https://djnnwndagrfti.cloudfront.net/content/nra/myDesignPro_image1.jpg','https://djnnwndagrfti.cloudfront.net/content/nra/myDesignPro_image3.jpg','https://djnnwndagrfti.cloudfront.net/content/nra/myDesignPro_image2.png', ],
      videos: ['E4dqTGHWWyE']
    },
    {
      title: 'Expansive Solutions for Prepared Foods',
      number: 7,
      coordinates: {
        top: '69%',
        left: '56%'
      },
      link: 'https://structuralconcepts.com/arm',
      linkTitle: 'Learn About the ARM',
      content: toParagraph('Create seamless lineups of heated, refrigerated and freshly prepared foods using merchandisers that transition beautifully from one offering to the next.\n\nAlignext allows for multiple merchandisers lined up together with a seamless appearance to eliminate visual distractions and place all the attention on the food inside. '),
      images: ['https://djnnwndagrfti.cloudfront.net/content/nra/Expansive_image1.jpg', 'https://djnnwndagrfti.cloudfront.net/content/nra/Expansive_image2.jpg'],
    },
    {
      title: 'MD Door Units (MD485DR & MD685DR)',
      number: 8,
      coordinates: {
        top: '58%',
        left: '71%'
      },
      link: 'https://structuralconcepts.com/products/md485dr-md685dr',
      linkTitle: 'View Product',
      content: toParagraph('Massive size stands as a strategic advantage, accommodating an extraordinary merchandising capacity. Self-service, door-equipped design promotes accessibility and encourages customers to explore the extensive array of fresh offerings.\n\nIn high foot traffic environments typical of retail spaces, the need for frequent refills is minimized, ensuring a seamless and uninterrupted customer experience.'),
      images: ['https://djnnwndagrfti.cloudfront.net/content/nra/MD-Door-Units_image1.jpg', 'https://djnnwndagrfti.cloudfront.net/content/nra/MD-Door-Units_image2.jpg', 'https://djnnwndagrfti.cloudfront.net/content/nra/MD-Door-Units_image3.jpg', 'https://djnnwndagrfti.cloudfront.net/content/nra/MD-Door-Units_image4.jpg'],
    },
  ]
};


const slideEight = {
  title: 'View Eight',
  image: 'assets/img/slide-8.png',
  thumb: 'assets/img/slide-8.png',
  hotspots: [
    {
      title: 'Expansive Solutions for Prepared Foods',
      number: 7,
      coordinates: {
        top: '60%',
        left: '72%'
      },
      link: 'https://structuralconcepts.com/arm',
      linkTitle: 'Learn About the ARM',
      content: toParagraph('Create seamless lineups of heated, refrigerated and freshly prepared foods using merchandisers that transition beautifully from one offering to the next.\n\nAlignext allows for multiple merchandisers lined up together with a seamless appearance to eliminate visual distractions and place all the attention on the food inside. '),
      images: ['https://djnnwndagrfti.cloudfront.net/content/nra/Expansive_image1.jpg', 'https://djnnwndagrfti.cloudfront.net/content/nra/Expansive_image2.jpg'],
    },
    {
      title: 'MD Door Units (MD485DR & MD685DR)',
      number: 8,
      coordinates: {
        top: '44%',
        left: '82%'
      },
      link: 'https://structuralconcepts.com/products/md485dr-md685dr',
      linkTitle: 'View Product',
      content: toParagraph('Massive size stands as a strategic advantage, accommodating an extraordinary merchandising capacity. Self-service, door-equipped design promotes accessibility and encourages customers to explore the extensive array of fresh offerings.\n\nIn high foot traffic environments typical of retail spaces, the need for frequent refills is minimized, ensuring a seamless and uninterrupted customer experience.'),
      images: ['https://djnnwndagrfti.cloudfront.net/content/nra/MD-Door-Units_image1.jpg', 'https://djnnwndagrfti.cloudfront.net/content/nra/MD-Door-Units_image2.jpg', 'https://djnnwndagrfti.cloudfront.net/content/nra/MD-Door-Units_image3.jpg', 'https://djnnwndagrfti.cloudfront.net/content/nra/MD-Door-Units_image4.jpg'],
    },
  ]
};

const slides = [
  slideOne,
  slideTwo,
  slideThree,
  slideFour,
  slideFive,
  slideSix,
  slideSeven,
  slideEight,
];


export const slideData = slides.map((slide, parentIndex) => ({
  ...slide,
  hotspots: slide.hotspots.map(hotspot => ({
    ...hotspot,
    parentIndex
  }))
}));
